import { forwardRef } from "react";
import { cssModule, mergeProps } from "../../shared";
import { ThemeProvider, useThemeContext } from "../../styling";
import { Transition } from "../../transition";
import { createPortal } from "react-dom";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerOverlay({
  as = DefaultElement,
  borderOffset,
  children,
  containerElement,
  forwardedRef,
  show,
  zIndex,
  ...rest
}) {
  // Since the overlay is rendered through a portal it might not be embedded in the theme DOM element.
  const {
    colorScheme,
    theme
  } = useThemeContext();

  const content = /*#__PURE__*/_jsx(Transition, { ...mergeProps(rest, {
      as,
      className: cssModule( // The "o-ui" class is a small hack to allow nesting ThemeProvider inside the transition instead of outside to prevent rendering a div when the overlay is not visible.
      // Since the transition component use the "o-ui-fade-in" and "o-ui-fade-out" classes which are using CSS variables declared inside an ".o-ui" class
      // we must render the class somewhere.
      "o-ui", "overlay", borderOffset && "overlay-has-border-offset"),
      enter: "o-ui-fade-in",
      leave: "o-ui-fade-out",
      ref: forwardedRef,
      show,
      style: {
        "--o-ui-overlay-border-offset": borderOffset
      },
      zIndex
    }),
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      colorScheme: colorScheme,
      theme: theme,
      children: children
    })
  });

  return /*#__PURE__*/createPortal(content, containerElement || document.body);
}
InnerOverlay.defaultElement = DefaultElement;
export const Overlay = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerOverlay, { ...props,
  forwardedRef: ref
}));